import { Month } from "@js-joda/core";

export function decreaseScheduleByMonth(
  scheduleMonth: Month,
  scheduleYear: number,
  setScheduleMonth: (month: Month) => void,
  setScheduleYear: (year: number) => void
) {
  const month = scheduleMonth.minus(1);
  let year = scheduleYear;

  if (month.value() === 12) {
    year -= 1;
  }

  setScheduleMonth(month);
  setScheduleYear(year);
}

export function increaseScheduleByMonth(
  scheduleMonth: Month,
  scheduleYear: number,
  setScheduleMonth: (month: Month) => void,
  setScheduleYear: (year: number) => void
) {
  const month = scheduleMonth.plus(1);
  let year = scheduleYear;

  if (month.value() === 1) {
    year += 1;
  }

  setScheduleMonth(month);
  setScheduleYear(year);
}

export function changeSchedule(
  scheduleMonth: Month,
  scheduleYear: number,
  newMonth: number,
  newYear: number,
  setScheduleMonth: (month: Month) => void,
  setScheduleYear: (year: number) => void
) {
  if (!isNaN(newMonth) && !isNaN(newYear)) {
    if (scheduleMonth.value() !== newMonth) {
      setScheduleMonth(Month.of(newMonth));
    }

    if (scheduleYear !== newYear) {
      setScheduleYear(newYear);
    }
  }
}
